// Locale files for the `common` messages, loaded at build time and keyed by locale.
// Adding a locale is dropping a `<locale>.json` in beside the others — no code change.
const localeModules = import.meta.glob("./common/*.json", { eager: true });

const messages = {};
for (const path in localeModules) {
  const locale = path.match(/\.\/common\/(.+)\.json$/)?.[1];
  if (locale) {
    messages[locale] = localeModules[path].default || localeModules[path];
  }
}

export default messages;
